import React from 'react'; // eslint-disable-line
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _actions from '../../actions';
import MenuStyleList from '../../components/menuItems/MenuStyleList';
import VersionBox from '../../components/common/VersionBox';
import constants from '../../constants';
import SortableMenuItemList from '../../components/menuItems/SortableMenuItemList';
import PreviewEnableModules from '../../components/preview/PreviewEnableModules';
import Exclamation from '../../components/svg/Exclamation';
import i18n from '../../i18n';
import { findCheckInFromMenus } from '../../utilities/utils';

class ConfigureMenu extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            activeMenuItems: [],
            showPreview: true,
        };
        this.handleMenuItemChange = this.handleMenuItemChange.bind(this);
        this.handleMenuStyleChange = this.handleMenuStyleChange.bind(this);
        this.updateVersionForFieldWithValue = this.updateVersionForFieldWithValue.bind(this);
        this.handleMenuItemsDisplayOrderChange = this.handleMenuItemsDisplayOrderChange.bind(this);
        this.runMenuItemUpdate = this.runMenuItemUpdate.bind(this);
    }

    componentDidMount() {
        this.props.actions.getProjectVersionMenuItems(this.props.match.params.projectId);
        this.props.actions.getProjectVersion(this.props.match.params.projectId);
        this.props.actions.getProjectVersionModules(this.props.match.params.projectId);
    }

    componentDidUpdate(prevProps) {
        if (!this.props.menuItems.inProgress && prevProps.menuItems.inProgress) {
            // eslint-disable-next-line react/no-did-update-set-state
            const menuItems = this.props.menuItems.select?.length > 0 ? this.props.menuItems.select : this.props.menuItems.data
            this.setState({ activeMenuItems: menuItems });
        }
    }

    handleMenuItemChange(field, val, menuItem) {
        this.props.actions.updateMenuItemParameter(
            this.props.match.params.projectId, menuItem.subType, menuItem.type, field, val,
        );
    }

    handleMenuStyleChange(menuStyle) {
        this.updateVersionForFieldWithValue('menuStyle', menuStyle);
    }

    handleMenuItemsDisplayOrderChange(menuItems) {
        this.props.actions.bulkUpdateMenuItems(this.props.match.params.projectId, menuItems);
    }

    updateVersionForFieldWithValue(field, val) {
        const version = this.props.versions.select;
        version[field] = val;

        this.props.actions.updateProjectVersionbyParameter(
            this.props.match.params.projectId,
            field,
            val,
        );
    }

    updateMenuItem(menuItem) {
        if (menuItem.title === '') {
            // eslint-disable-next-line no-param-reassign
            menuItem.title = constants.MenuItemSubType
                .find((mt) => { return mt.Id === menuItem.subType; }).Name;
        }
        this.runMenuItemUpdate(menuItem);
    }

    runMenuItemUpdate(menuItem) {
        this.props.actions.updateMenuItem(
            this.props.match.params.projectId, menuItem.id, menuItem, true,
        );
        // eslint-disable-next-line react/no-access-state-in-setstate
        const menuItems = this.state.activeMenuItems
            .map((item) => {
                // eslint-disable-next-line no-return-assign,no-param-reassign
                return item.id = menuItem.id ? { ...item, title: menuItem.title } : item;
            });
        this.setState({ activeMenuItems: menuItems });
    }

    render() {
        const version = this.props.versions.select;
        let activeCheckin = findCheckInFromMenus(this.props.menuItems.data);
        const previewMenuItems = (
            <PreviewEnableModules
                menuStyle={version.menuStyle}
                menuItems={this.props.menuItems.select?.length > 0 ? this.props.menuItems.select : this.props.menuItems.data}
                churchName={this.props.versions.select.churchName}
                actionColor={this.props.versions.select.actionColor}
                accentColor={this.props.versions.select.accentColor}
                secondaryText={this.props.versions.select.secondaryText}
                primaryText={this.props.versions.select.primaryText}
                checkin={this.props.flags.results?.chMSIntegration
                && this.props.flags.results?.chMSCheckIn
                && activeCheckin}
            />
        );
        const form = (
            <div id="enable-menuItems-form" className="form-wrapper">
                <h1 id="enable-menuItems-header">{i18n.t('menuItems.enable.header')}</h1>

                <p id="enable-menuItems-subhead" className="lead">{i18n.t('menuItems.enable.subtitle')}</p>

                <div className="general-section choose-menu-style">

                    <h2 className="section-name">{i18n.t('menuItems.enable.section1')}</h2>
                    {version.id && (
                        <MenuStyleList
                            onChange={this.handleMenuStyleChange}
                            selectedMenuStyle={version.menuStyle}
                        />
                    )}
                </div>
                <div className="general-section enable-sort-menuItems">
                    <h2 className="section-name">{i18n.t('menuItems.enable.section2')}</h2>
                    {this.state.activeMenuItems?.length > 0 && (
                        <>
                            <div id="menuItems" className={`${version.menuStyle === 1 ? 'bottom' : ''} ${this.state.activeMenuItems.length > 5 ? 'more' : ''} menuItem-list`}>
                                <SortableMenuItemList
                                    userSelectedIcons={this.props.flags?.results?.userSelectedIcons}
                                    menuItems={this.state.activeMenuItems}
                                    onMenuItemsDisplayOrderChange={this.handleMenuItemsDisplayOrderChange}
                                    onSingleMenuItemChange={this.handleMenuItemChange}
                                    modules={this.props.modules}
                                />
                            </div>
                            {version.menuStyle === 1 && this.state.activeMenuItems.length > 5 && (
                                <div id="menu-help-text" className="menu-help-text">
                                    <Exclamation />
                                    {i18n.t('menuItems.help-overflow')}
                                </div>
                            )}
                        </>
                    )}
                </div>
            </div>
        );
        return (
            <VersionBox
                name={version.name}
                versionNumber={version.version}
                saving={this.props.versions.inProgress || this.props.versions.validationInProgress}
                justSaved={this.props.menuItems.justSaved}
                menuSection="Design"
                menuItem="Menu"
                previewCssClass="modules_enable-modules"
                previewChild={previewMenuItems}
                configCode={this.props.versions.select.configCode}
                showPreview={this.state.showPreview}
                x
            >
                <div id="enable-menuItems-page" className="content-inside">
                    {form}
                </div>

            </VersionBox>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        ...state,
        ...ownProps,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(_actions, dispatch),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ConfigureMenu);
